import { render, staticRenderFns } from "./DesktopJoinPage.vue?vue&type=template&id=495c0020&scoped=true"
import script from "./DesktopJoinPage.vue?vue&type=script&lang=js"
export * from "./DesktopJoinPage.vue?vue&type=script&lang=js"
import style0 from "./DesktopJoinPage.vue?vue&type=style&index=0&id=495c0020&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495c0020",
  null
  
)

export default component.exports